import type { BackgroundColorModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import { useOptimisticModifierValue } from "@v2/features/modifiers/hooks/useOptimisticModifierValue";
import { useOverridableState } from "replo-runtime/shared/hooks/useOverridableState";

import ColorSelector from "./ColorSelector";

interface BackgroundModifierProps {
  onChange: (modifiers: BackgroundColorModifierValue[]) => void;
}

const BackgroundModifierComponent: React.FC<BackgroundModifierProps> = ({
  onChange,
}) => {
  const extractedColor =
    useOptimisticModifierValue({
      modifierType: { type: "backgroundColor", value: null },
      extractor: (elementDesignation) => {
        return (
          elementDesignation.element.styleOverrides?.backgroundColor ?? null
        );
      },
    }) ?? null;

  const [currentColor, setCurrentColor] = useOverridableState(
    extractedColor,
    React.useCallback(
      (color: string | null) => {
        const modifier: BackgroundColorModifierValue = {
          type: "backgroundColor",
          value: color,
        };
        onChange([modifier]);
      },
      [onChange],
    ),
  );

  return <ColorSelector value={currentColor} onChange={setCurrentColor} />;
};

export default BackgroundModifierComponent;
